<template>
  <div class="common_problem_wrap_mobile">
      <van-collapse :border="mob_hasborder" :accordion="mob_isaccordion" v-model="mob_activeNames" @change="collapseChange">
        <van-collapse-item :border="mob_hasborder" name="1">
          <template #title>
            <div class="common_title_wrap" style="padding-left: 0.555556rem;">
              <div class="common_title_left">
                <div class="common_tleft_icon">
                  <img src="@/assets/mobimg/mob_pla_logo.png" alt="" />
                </div>
              </div>
            </div>
          </template>

          <template #right-icon>
            <div class="common_title_right" style="padding-right: 0.555556rem;">
              <div class="common_trview">
                <img v-if="collapseIsOpen('1')" src="@/assets/mobimg/mob_navclose_icon.png" alt="" />
                <img v-else src="@/assets/mobimg/mob_navopen_icon.png" alt="" />
              </div>
            </div>
          </template>

          <div class="common_problem_view_mobile scaletop-1px">
            <div class="common_children_wrap" style="padding-left: 0;">
              <div class="children_cont_items scale-1px" style="font-weight: bold;" :class="activeNav == 'Inicio' ? 'children_citactive' : ''" @click="getActive('home')">INICIO</div>
              <div class="children_cont_items scale-1px" style="font-weight: bold;" :class="activeNav == 'Aviso' ? 'children_citactive' : ''" @click="getActive('notice')">PREVENCIÓN DE FRAUDE</div>
              <div class="children_cont_items scale-1px" style="font-weight: bold;" :class="activeNav == 'sobre' ? 'children_citactive' : ''" @click="getActive('about')">CENTRO DE AYUDA</div>
              <!--<div class="children_cont_items scale-1px" style="font-weight: bold;" :class="activeNav == 'Aviso' ? 'children_citactive' : ''" @click="getActive('notice')">Introducción</div>
              <div class="children_cont_items scale-1px" style="font-weight: bold;" :class="activeNav == 'sobre' ? 'children_citactive' : ''" @click="getActive('about')">Sobre nosotros</div>-->
            </div>
          </div>

        </van-collapse-item>
      </van-collapse>
  </div>

</template>

<script>
  import mobileOrpc from "@/mixins/index";

  export default {
    name: "mobNav",
    props: ["activeNav"],
    mixins: [mobileOrpc],
    data() {
      return {
        mob_isaccordion: true,
        mob_hasborder: false,
        mob_activeNames: [],
        mob_chidone_Names: [],
      };
    },
    created() {

    },
    mounted() {
      console.log('是否为移动端')
      console.log(this.is_mobile)
    },
    methods: {
      collapseIsOpen(index){
        let useActiveNames = this.mob_activeNames;
        let isOpen = useActiveNames.indexOf(index);

        if(isOpen == -1){
          return false;
        } else {
          return true;
        }
      },
      chidoneIsOpen(index) {
        let useActiveNames = this.mob_chidone_Names;
        let isOpen = useActiveNames.indexOf(index);

        if(isOpen == -1){
          return false;
        } else {
          return true;
        }
      },
      collapseChange(e){
        console.log(e)
      },
      getActive(val) {
        let usePath = this.$route.path;
        if(usePath.indexOf(val) == -1){
          let url = "";
          switch (val) {
            case "home":
              url = "/home";
              break;
            case "notice":
              url = "/notice";
              break;
            case "about":
              url = "/about";
              break;
          }
          this.$router.push(url);
        }
      },
    },
  };
</script>

<style>
</style>
